<template>
    <div v-show='!alertHidden' class='alert-mask'>
        <div class='modal-box'>
            <img @click="cancelFun" class="closeBtn" src="/static/img/alert/close@2x.png">
            <span class='modal-title'>手机账号绑定</span>
            <span class='modal-message'>请绑定手机号，体验更优质的DC竞赛服务</span>
            <div class='input-box'>
                <img class='icon' src='/static/img/common/phone_icon.png'>
                <div @click='bindPickerChange'>{{newSelectArea}}</div>
                <input class="phone" v-model='bean.phone' @keyup='inputFun' placeholder='请输入手机号码'/>
            </div>
            <div class='input-box'>
                <img class='icon2' src='/static/img/common/email_icon.png'>
                <input class="auth" v-model='bean.phoneAuth' @keyup='inputFun' placeholder-class='placeholder-class' placeholder='请输入验证码'/>
                <span style='display:block;padding-left: 10px;' @click='getPhoneAuth'>{{mailAuthTxt}}</span>
            </div>

            <div v-if="btnClass" class='largeButton btn active' @click='submitChangeFun'>确定</div>
            <div v-else class='largeButton btn'>确定</div>
        </div>
        <select-picker
                ref="select1"
                pickerType="international_code"
                @handlePickerConfirm="handlePickerConfirm1">
        </select-picker>
    </div>
</template>
<script>
import selectPicker from '../picker/select-picker'
import api from '../../../api/api'
export default {
  name: 'set-phone-alert',
  components: {
    'select-picker': selectPicker
  },
  props: {
    alertHiddenBool: {
      type: Boolean,
      value: true
    }
  },
  data () {
    return {
      alertHidden: true,
      newSelectArea: '+86',
      bean: {
        phone: '',
        phoneAuth: ''
      },
      btnClass: false,
      // mailAuthText: this.$t('dc_lang.获取验证码'),
      countDown: 60, // 倒计时
      isCountDown: true// 是否可以点击获取验证码
    }
  },
  computed: {
    mailAuthTxt: { // 获取验证码按钮txt
      get () {
        if (this.isCountDown) {
          return this.$t('dc_lang.获取验证码')
        } else {
          return this.countDown + 's'
        }
      },
      set () {
        if (this.isCountDown) {
          return this.$t('dc_lang.获取验证码')
        } else {
          return this.countDown + 's'
        }
      }
    }
  },
  methods: {
    // 新输入号码选择地区
    bindPickerChange () {
      this.$refs.select1.showFun('phoneArea', this.newSelectArea)
    },
    handlePickerConfirm1 (data) {
      this.newSelectArea = data[0].id
    },
    inputFun () { // input输入
      let me = this, flag = true
      for (var item in me.bean) {
        if (me.bean[item] == '') {
          flag = false
        }
      }
      me.btnClass = flag
    },
    cancelFun () {
      this.alertHidden = true
      const me = this
      api.updateUserCollectInfoUrl().then((responses) => {
        me.common.axiosSuccessFun({
          this: me,
          fail: false,
          failBack () {
            var cookieArray = document.cookie.split('; ') // 得到分割的cookie名值对
            var cookie = new Object()
            var jumpPage = ''
            for (var i = 0; i < cookieArray.length; i++) {
              var arr = cookieArray[i].split('=') // 将名和值分开
              if (arr[0] == 'jumpPage')jumpPage = unescape(arr[1]) // 如果是指定的cookie，则返回它的值
            }
            if (jumpPage != '') {
              window.location.href = jumpPage

              var date = new Date()
              date.setTime(date.getTime() - 1)
              document.cookie = 'jumpPage=' + jumpPage + ';expires=' + date.toGMTString()
            }
          },
          callBack () {
            var cookieArray = document.cookie.split('; ') // 得到分割的cookie名值对
            var cookie = new Object()
            var jumpPage = ''
            for (var i = 0; i < cookieArray.length; i++) {
              var arr = cookieArray[i].split('=') // 将名和值分开
              if (arr[0] == 'jumpPage')jumpPage = unescape(arr[1]) // 如果是指定的cookie，则返回它的值
            }
            if (jumpPage != '') {
              window.location.href = jumpPage

              var date = new Date()
              date.setTime(date.getTime() - 1)
              document.cookie = 'jumpPage=' + jumpPage + ';expires=' + date.toGMTString()
            }
          }
        }, responses.data)
      }).catch((resp) => {
        me.common.axiosFailFun({
          this: me
        }, resp)
      })
      this.bean = {
        phone: '',
        phoneAuth: ''
      }
      clearInterval(me.timer)
      me.mailAuthTxt = this.mailAuthTxt
      me.isCountDown = true
    },

    // 用户有手机号,绑定新手机号码进行提交
    submitChangeFun () {
      let me = this
      api.userNameCheckUrl({
        userName: me.newSelectArea + '' + me.bean.phone,
        type: 'phone'
      }).then(response => {
        me.common.axiosSuccessFun({
          this: me,
          callBack () {
            me.submitFun()
          }
        }, response.data)
      }).catch((error) => {
        me.common.axiosFailFun({
          this: me
        }, error)
      })
    },

    // 点击发送验证码时候,检查手机格式&是否已经被使用
    getPhoneAuth () {
      let me = this
      if (me.bean.phone == '') {
        me.$parent.$parent.$refs.toastCompo.showFun({
          msg: '手机不能为空!',
          time: 800
        })
      } else {
        if (me.newSelectArea == '+86') {
          me.checkPhone(me.bean.phone, me.sendPhoneAuth)
        } else {
          me.sendPhoneAuth()
        }
      }
    },
    // 手机号码验证
    checkPhone (phone, callBack) {
      let me = this
      let re = /^1[3|4|5|6|7|8|9][0-9]{9}$/
      if (re.test(phone)) { // 手机验证通过
        if (callBack) {
          callBack()
        }
      } else {
        me.$parent.$parent.$refs.toastCompo.showFun({
          msg: '手机格式错误!',
          time: 800
        })
      }
    },
    // 发送手机验证码
    sendPhoneAuth () {
      let me = this
      if (me.isCountDown) {
        me.isCountDown = false
        api.userNameCheckUrl({ // 用户名check
          userName: me.newSelectArea + '' + me.bean.phone,
          type: 'phone'
        }).then((res) => {
          me.common.axiosSuccessFun({
            this: me,
            fail: true,
            url: '/mine',
            callBack (res) {
              api.clickCaptchaUrl().then((res) => { // 发送验证码
                me.common.axiosSuccessFun({
                  this: me,
                  url: '/mine',
                  callBack (res) {
                    api.sendBindingPhoneAuthUrl({// 手机绑定（发送验证码）
                      phone: me.newSelectArea + '' + me.bean.phone
                    }).then((res) => {
                      me.common.axiosSuccessFun({
                        this: me,
                        url: '/mine',
                        callBack (res) {
                          me.countDown = 60
                          me.timer = setInterval(() => {
                            if (me.countDown == 1) {
                              clearInterval(me.timer)
                              me.mailAuthTxt = this.mailAuthTxt
                              me.isCountDown = true
                            } else {
                              me.countDown--
                              me.mailAuthTxt = me.countDown + 's'
                            }
                          }, 1000)
                        },
                        failBack (res) {
                          me.isCountDown = true
                        }
                      }, res.data)
                    }).catch((error) => {
                      me.common.axiosFailFun({
                        this: me
                      }, error)
                    })
                  },
                  failBack () {
                    me.isCountDown = true
                  }
                }, res.data)
              }).catch((error) => {
                me.common.axiosFailFun({
                  this: me
                }, error)
              })
            },
            failBack () {
              me.isCountDown = true
            }
          }, res.data)
        }).catch((error) => {
          me.common.axiosFailFun({
            this: me
          }, error)
        })
      }
    },
    // 提交
    submitFun () {
      let me = this
      api.phoneVerifiedUrl({
        phoneAuth: me.bean.phoneAuth,
        phone: me.newSelectArea + me.bean.phone
      }).then(response => {
        me.common.axiosSuccessFun({
          this: me,
          callBack () {
            me.$parent.$parent.$refs.toastCompo.showFun({
              msg: '绑定成功！',
              time: 800
            })
            setTimeout(() => {
              me.$router.go(-1)// 返回上一页
            }, 1000)
          }
        }, response.data)
      }).catch((error) => {
        me.common.axiosFailFun({
          this: me
        }, error)
      })
    }
  }
}
</script>

<style scoped>
    .modal-box {
        width:594px;/*px*/
        height:530px;/*px*/
        left: 78px;/*px*/
        top: 300px;/*px*/
        overflow: hidden;
        position: fixed;
        box-sizing: border-box;
        background: #fff;
        border-radius: 12px;
        padding: 44px 48px;
        font-family: PingFangSC-Medium;
    }

    .modal-title {
        font-size:36px;/*px*/
        text-align: center;
        display: block;
        font-family:MicrosoftYaHei;
        color:rgba(51,51,51,1);
        line-height:54px;
        font-weight: bold;
        margin-bottom: 10px;
        letter-spacing:1px;
    }
    .modal-message {
        width:498px;
        height:36px;
        font-size:24px;/*px*/
        text-align: center;
        display: block;
        font-family:MicrosoftYaHei;
        color:rgba(74,89,124,1);
        line-height:36px;
        letter-spacing:2px;
    }
    .top-coupon{
        margin-top: -130px;
    }
    .alert-mask{
        width: 100%;
        height: 100%;
        position: fixed;
        top:0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 1000;
        background: rgba(0,0,0,0.50);
    }
    .closeBtn{
        width:48px;
        height: 48px;
        position: absolute;
        right: 20px;
        top:20px
    }
    /* input框 */
    .input-box{
        width: 100%;
        background: #fff;
        height: 72px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        padding: 12px 20px 12px 12px;
        margin-top: 40px;
        justify-content: flex-start;
        border:2px solid rgba(194,196,203,1);
    }
    .input-box .icon{
        width: 30px;
        height: 40px;
        margin-right: 12px;
    }
    .input-box .icon2{
        width: 40px;
        height: 32px;
        margin-right: 12px;
    }
    .input-box input::-webkit-input-placeholder{
        font-size: 28px;/*px*/
        color: #BDC1C7;
    }
    .input-box input.phone{
        max-width: 360px;
    }
    .input-box input.auth{
        max-width: 248px;
    }
    .input-box input{
        flex: 1;
        box-sizing: border-box;
        outline: none;
        /*width: 303px;!*px*!*/
        border: none;
        font-size: 32px;/*px*/
        padding: 0 10px;/*px*/
        color: #17181A;
    }
    .input-box span{
        font-size: 28px;/*px*/
        color: #4DA6FF;
    }
    .input-box div{
        /*width: 118px;!*px*!*/
        text-align: left;
        font-size: 32px;/*px*/
        padding-right: 16px;
        color: #17181A;
        border-right: 2px solid #E9E9E9;
    }
    /* 按钮 */
    .btn{
        color: #fff;
        background:  #BDC1C7;
        margin: 40px auto 0;
        text-align: center;
        width: 100%;
        height: 72px;
        line-height: 72px;
        border-radius: 0;
        font-size:28px;/*px*/
        letter-spacing:1px;
    }
    .active{
        color: #fff;
        background: #4DA6FF;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/set-phone/set-phone.vue